import { useOfficeComponentContext } from '@office-start/component-context-service';
import { useQuery } from '@office-start/data-fetching';
import { useEdgeworthConfig } from '@office-start/edgeworth-config-service';
import { useIdentity } from '@office-start/identity-service';
import { useMemo } from 'react';
import { recentQueryKey } from '../models/Constants';
import { fetchRecent } from '../operations/fetchRecent';
import { getRecentRequestApiOptions } from '../utilities/RequestUtilities';
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function useEdgeworthRecent(filterFileType) {
    var context = useOfficeComponentContext().data;
    var identity = useIdentity().data;
    var config = useEdgeworthConfig().data;
    var query = useMemo(function () {
        if (filterFileType) {
            recentQueryKey.push(filterFileType);
        }
        return recentQueryKey;
    }, [filterFileType]);
    return useQuery(query, function () {
        var _a;
        var currentPage = ((_a = context === null || context === void 0 ? void 0 : context.router) === null || _a === void 0 ? void 0 : _a.getCurrentPageForLogging())
            ? context.router.getCurrentPageForLogging()
            : '';
        var apiOptions = getRecentRequestApiOptions(
        /* eslint-disable @typescript-eslint/no-non-null-assertion */
        config, context, identity, 
        /* eslint-enable @typescript-eslint/no-non-null-assertion */
        currentPage, filterFileType && [filterFileType]);
        if (config === null || config === void 0 ? void 0 : config.backgroundSyncEnabled) {
            apiOptions.enableBackgroundSync = true;
        }
        return fetchRecent(apiOptions);
    }, {
        cacheTime: Infinity,
        staleTime: Infinity,
        enabled: !!(context && config && identity),
        refetchOnWindowFocus: false,
    });
}
//# sourceMappingURL=useEdgeworthRecent.js.map